// source: dash/v1/lesson_unit_content.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var dash_v1_models_pb = require('../../dash/v1/models_pb.js');
goog.object.extend(proto, dash_v1_models_pb);
var types_v1_status_pb = require('../../types/v1/status_pb.js');
goog.object.extend(proto, types_v1_status_pb);
goog.exportSymbol('proto.dash.v1.GetLessonUnitContentRequest', null, global);
goog.exportSymbol('proto.dash.v1.GetLessonUnitContentResponse', null, global);
goog.exportSymbol('proto.dash.v1.ListLessonUnitContentsRequest', null, global);
goog.exportSymbol('proto.dash.v1.ListLessonUnitContentsResponse', null, global);
goog.exportSymbol('proto.dash.v1.PutLessonUnitContentRequest', null, global);
goog.exportSymbol('proto.dash.v1.PutLessonUnitContentResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.v1.GetLessonUnitContentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.v1.GetLessonUnitContentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.v1.GetLessonUnitContentRequest.displayName = 'proto.dash.v1.GetLessonUnitContentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.v1.GetLessonUnitContentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.v1.GetLessonUnitContentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.v1.GetLessonUnitContentResponse.displayName = 'proto.dash.v1.GetLessonUnitContentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.v1.PutLessonUnitContentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.v1.PutLessonUnitContentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.v1.PutLessonUnitContentRequest.displayName = 'proto.dash.v1.PutLessonUnitContentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.v1.PutLessonUnitContentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.v1.PutLessonUnitContentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.v1.PutLessonUnitContentResponse.displayName = 'proto.dash.v1.PutLessonUnitContentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.v1.ListLessonUnitContentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.v1.ListLessonUnitContentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.v1.ListLessonUnitContentsRequest.displayName = 'proto.dash.v1.ListLessonUnitContentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.v1.ListLessonUnitContentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dash.v1.ListLessonUnitContentsResponse.repeatedFields_, null);
};
goog.inherits(proto.dash.v1.ListLessonUnitContentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.v1.ListLessonUnitContentsResponse.displayName = 'proto.dash.v1.ListLessonUnitContentsResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.v1.GetLessonUnitContentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.v1.GetLessonUnitContentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.v1.GetLessonUnitContentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.GetLessonUnitContentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.v1.GetLessonUnitContentRequest}
 */
proto.dash.v1.GetLessonUnitContentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.v1.GetLessonUnitContentRequest;
  return proto.dash.v1.GetLessonUnitContentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.v1.GetLessonUnitContentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.v1.GetLessonUnitContentRequest}
 */
proto.dash.v1.GetLessonUnitContentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.v1.GetLessonUnitContentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.v1.GetLessonUnitContentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.v1.GetLessonUnitContentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.GetLessonUnitContentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.dash.v1.GetLessonUnitContentRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dash.v1.GetLessonUnitContentRequest} returns this
 */
proto.dash.v1.GetLessonUnitContentRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.v1.GetLessonUnitContentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.v1.GetLessonUnitContentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.v1.GetLessonUnitContentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.GetLessonUnitContentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    lessonUnitContent: (f = msg.getLessonUnitContent()) && dash_v1_models_pb.LessonUnitContent.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.v1.GetLessonUnitContentResponse}
 */
proto.dash.v1.GetLessonUnitContentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.v1.GetLessonUnitContentResponse;
  return proto.dash.v1.GetLessonUnitContentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.v1.GetLessonUnitContentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.v1.GetLessonUnitContentResponse}
 */
proto.dash.v1.GetLessonUnitContentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new dash_v1_models_pb.LessonUnitContent;
      reader.readMessage(value,dash_v1_models_pb.LessonUnitContent.deserializeBinaryFromReader);
      msg.setLessonUnitContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.v1.GetLessonUnitContentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.v1.GetLessonUnitContentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.v1.GetLessonUnitContentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.GetLessonUnitContentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLessonUnitContent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      dash_v1_models_pb.LessonUnitContent.serializeBinaryToWriter
    );
  }
};


/**
 * optional LessonUnitContent lesson_unit_content = 1;
 * @return {?proto.dash.v1.LessonUnitContent}
 */
proto.dash.v1.GetLessonUnitContentResponse.prototype.getLessonUnitContent = function() {
  return /** @type{?proto.dash.v1.LessonUnitContent} */ (
    jspb.Message.getWrapperField(this, dash_v1_models_pb.LessonUnitContent, 1));
};


/**
 * @param {?proto.dash.v1.LessonUnitContent|undefined} value
 * @return {!proto.dash.v1.GetLessonUnitContentResponse} returns this
*/
proto.dash.v1.GetLessonUnitContentResponse.prototype.setLessonUnitContent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.v1.GetLessonUnitContentResponse} returns this
 */
proto.dash.v1.GetLessonUnitContentResponse.prototype.clearLessonUnitContent = function() {
  return this.setLessonUnitContent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.v1.GetLessonUnitContentResponse.prototype.hasLessonUnitContent = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.v1.PutLessonUnitContentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.v1.PutLessonUnitContentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.v1.PutLessonUnitContentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.PutLessonUnitContentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    lessonUnitContent: (f = msg.getLessonUnitContent()) && dash_v1_models_pb.LessonUnitContent.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.v1.PutLessonUnitContentRequest}
 */
proto.dash.v1.PutLessonUnitContentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.v1.PutLessonUnitContentRequest;
  return proto.dash.v1.PutLessonUnitContentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.v1.PutLessonUnitContentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.v1.PutLessonUnitContentRequest}
 */
proto.dash.v1.PutLessonUnitContentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new dash_v1_models_pb.LessonUnitContent;
      reader.readMessage(value,dash_v1_models_pb.LessonUnitContent.deserializeBinaryFromReader);
      msg.setLessonUnitContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.v1.PutLessonUnitContentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.v1.PutLessonUnitContentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.v1.PutLessonUnitContentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.PutLessonUnitContentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLessonUnitContent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      dash_v1_models_pb.LessonUnitContent.serializeBinaryToWriter
    );
  }
};


/**
 * optional LessonUnitContent lesson_unit_content = 1;
 * @return {?proto.dash.v1.LessonUnitContent}
 */
proto.dash.v1.PutLessonUnitContentRequest.prototype.getLessonUnitContent = function() {
  return /** @type{?proto.dash.v1.LessonUnitContent} */ (
    jspb.Message.getWrapperField(this, dash_v1_models_pb.LessonUnitContent, 1));
};


/**
 * @param {?proto.dash.v1.LessonUnitContent|undefined} value
 * @return {!proto.dash.v1.PutLessonUnitContentRequest} returns this
*/
proto.dash.v1.PutLessonUnitContentRequest.prototype.setLessonUnitContent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.v1.PutLessonUnitContentRequest} returns this
 */
proto.dash.v1.PutLessonUnitContentRequest.prototype.clearLessonUnitContent = function() {
  return this.setLessonUnitContent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.v1.PutLessonUnitContentRequest.prototype.hasLessonUnitContent = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.v1.PutLessonUnitContentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.v1.PutLessonUnitContentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.v1.PutLessonUnitContentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.PutLessonUnitContentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    lessonUnitContent: (f = msg.getLessonUnitContent()) && dash_v1_models_pb.LessonUnitContent.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.v1.PutLessonUnitContentResponse}
 */
proto.dash.v1.PutLessonUnitContentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.v1.PutLessonUnitContentResponse;
  return proto.dash.v1.PutLessonUnitContentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.v1.PutLessonUnitContentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.v1.PutLessonUnitContentResponse}
 */
proto.dash.v1.PutLessonUnitContentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new dash_v1_models_pb.LessonUnitContent;
      reader.readMessage(value,dash_v1_models_pb.LessonUnitContent.deserializeBinaryFromReader);
      msg.setLessonUnitContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.v1.PutLessonUnitContentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.v1.PutLessonUnitContentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.v1.PutLessonUnitContentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.PutLessonUnitContentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLessonUnitContent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      dash_v1_models_pb.LessonUnitContent.serializeBinaryToWriter
    );
  }
};


/**
 * optional LessonUnitContent lesson_unit_content = 1;
 * @return {?proto.dash.v1.LessonUnitContent}
 */
proto.dash.v1.PutLessonUnitContentResponse.prototype.getLessonUnitContent = function() {
  return /** @type{?proto.dash.v1.LessonUnitContent} */ (
    jspb.Message.getWrapperField(this, dash_v1_models_pb.LessonUnitContent, 1));
};


/**
 * @param {?proto.dash.v1.LessonUnitContent|undefined} value
 * @return {!proto.dash.v1.PutLessonUnitContentResponse} returns this
*/
proto.dash.v1.PutLessonUnitContentResponse.prototype.setLessonUnitContent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.v1.PutLessonUnitContentResponse} returns this
 */
proto.dash.v1.PutLessonUnitContentResponse.prototype.clearLessonUnitContent = function() {
  return this.setLessonUnitContent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.v1.PutLessonUnitContentResponse.prototype.hasLessonUnitContent = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.v1.ListLessonUnitContentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.v1.ListLessonUnitContentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.v1.ListLessonUnitContentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.ListLessonUnitContentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    lessonUnitId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.v1.ListLessonUnitContentsRequest}
 */
proto.dash.v1.ListLessonUnitContentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.v1.ListLessonUnitContentsRequest;
  return proto.dash.v1.ListLessonUnitContentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.v1.ListLessonUnitContentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.v1.ListLessonUnitContentsRequest}
 */
proto.dash.v1.ListLessonUnitContentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLessonUnitId(value);
      break;
    case 3:
      var value = /** @type {!proto.types.v1.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.v1.ListLessonUnitContentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.v1.ListLessonUnitContentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.v1.ListLessonUnitContentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.ListLessonUnitContentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLessonUnitId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional int32 lesson_unit_id = 1;
 * @return {number}
 */
proto.dash.v1.ListLessonUnitContentsRequest.prototype.getLessonUnitId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dash.v1.ListLessonUnitContentsRequest} returns this
 */
proto.dash.v1.ListLessonUnitContentsRequest.prototype.setLessonUnitId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional types.v1.Status status = 3;
 * @return {!proto.types.v1.Status}
 */
proto.dash.v1.ListLessonUnitContentsRequest.prototype.getStatus = function() {
  return /** @type {!proto.types.v1.Status} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.types.v1.Status} value
 * @return {!proto.dash.v1.ListLessonUnitContentsRequest} returns this
 */
proto.dash.v1.ListLessonUnitContentsRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dash.v1.ListLessonUnitContentsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.v1.ListLessonUnitContentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.v1.ListLessonUnitContentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.v1.ListLessonUnitContentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.ListLessonUnitContentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    lessonUnitContentsList: jspb.Message.toObjectList(msg.getLessonUnitContentsList(),
    dash_v1_models_pb.LessonUnitContent.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.v1.ListLessonUnitContentsResponse}
 */
proto.dash.v1.ListLessonUnitContentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.v1.ListLessonUnitContentsResponse;
  return proto.dash.v1.ListLessonUnitContentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.v1.ListLessonUnitContentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.v1.ListLessonUnitContentsResponse}
 */
proto.dash.v1.ListLessonUnitContentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new dash_v1_models_pb.LessonUnitContent;
      reader.readMessage(value,dash_v1_models_pb.LessonUnitContent.deserializeBinaryFromReader);
      msg.addLessonUnitContents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.v1.ListLessonUnitContentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.v1.ListLessonUnitContentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.v1.ListLessonUnitContentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.v1.ListLessonUnitContentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLessonUnitContentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      dash_v1_models_pb.LessonUnitContent.serializeBinaryToWriter
    );
  }
};


/**
 * repeated LessonUnitContent lesson_unit_contents = 1;
 * @return {!Array<!proto.dash.v1.LessonUnitContent>}
 */
proto.dash.v1.ListLessonUnitContentsResponse.prototype.getLessonUnitContentsList = function() {
  return /** @type{!Array<!proto.dash.v1.LessonUnitContent>} */ (
    jspb.Message.getRepeatedWrapperField(this, dash_v1_models_pb.LessonUnitContent, 1));
};


/**
 * @param {!Array<!proto.dash.v1.LessonUnitContent>} value
 * @return {!proto.dash.v1.ListLessonUnitContentsResponse} returns this
*/
proto.dash.v1.ListLessonUnitContentsResponse.prototype.setLessonUnitContentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.dash.v1.LessonUnitContent=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dash.v1.LessonUnitContent}
 */
proto.dash.v1.ListLessonUnitContentsResponse.prototype.addLessonUnitContents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.dash.v1.LessonUnitContent, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dash.v1.ListLessonUnitContentsResponse} returns this
 */
proto.dash.v1.ListLessonUnitContentsResponse.prototype.clearLessonUnitContentsList = function() {
  return this.setLessonUnitContentsList([]);
};


goog.object.extend(exports, proto.dash.v1);
